import { PropsWithChildren, useEffect, useState } from 'react'
import axios from 'axios'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useStore } from 'hooks/useStore'

export enum Term {
	TermsOfService = 'Terms of Service',
	PrivacyPolicy = 'Privacy Policy',
	MarketingTerms = 'Marketing Terms',
}

interface Props {
	term: Term
}

export default function TermsContent({ term }: PropsWithChildren<Props>) {
	const { currentTerms } = useStore()
	const [termContent, setTermContent] = useState<any>('')

	useEffect(() => {
		const axiosConfig = {
			headers: {
				'Content-Type': 'text/html',
				'Access-Control-Allow-Origin': '*',
			},
		}
		const termUrl =
			term === Term.TermsOfService
				? currentTerms?.termsAndConditionsUrl
				: term === Term.MarketingTerms
					? currentTerms?.marketingTermsUrl
					: currentTerms?.privacyPolicyUrl
		if (termUrl) {
			axios
				.get(termUrl, axiosConfig)
				.then(response => {
					setTermContent(response.data)
				})
			// .catch(error => {})
		}
	}, [currentTerms, term])

	const createMarkup = (html: any) => {
		return { __html: html }
	}

	return termContent ? (
		<div className="text-left" dangerouslySetInnerHTML={createMarkup(termContent)} />
	) : (
		<div className="flex justify-center items-center py-4">
			<FontAwesomeIcon icon={['fas', 'spinner']} size="lg" spin className="text-white" />
		</div>
	)
}
